"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetsHandle = void 0;
exports.createEmptyBudget = createEmptyBudget;
const BudgetHandle_1 = require("./BudgetHandle");
function getBudgetDateKey(budget) {
    return "" + new Date(budget.year || 0, budget.month || 0).getTime();
}
function createEmptyBudget(teamId) {
    return {
        team: teamId,
        bankHours: 0,
        teamHours: 0,
        opsHours: 0,
        emHours: 0,
    };
}
class BudgetsHandle {
    constructor(budgets, contractTypes) {
        this.budgets = budgets;
        this.contractTypes = contractTypes;
    }
    withAddedBudget(budget) {
        const clone = JSON.parse(JSON.stringify(budget));
        const merged = this.budgets.reduce((map, budget) => {
            map.set(getBudgetDateKey(budget), budget);
            return map;
        }, new Map());
        merged.set(getBudgetDateKey(clone), clone);
        const newBudgets = new BudgetsHandle(Array.from(merged.values()), this.contractTypes);
        const sorted = newBudgets.getSorted();
        if (!budget.team) {
            const newBudgetIndex = sorted.budgets.findIndex((b) => b === clone);
            if (newBudgetIndex > 0) {
                const previous = sorted.budgets[newBudgetIndex - 1];
                clone.team = previous.team || "";
            }
        }
        return sorted;
    }
    getSorted() {
        const budgets = this.budgets.slice(0);
        budgets.sort((b1, b2) => {
            const d1 = new Date(b1.year || 0, b1.month || 0);
            const d2 = new Date(b2.year || 0, b2.month || 0);
            return d1.getTime() - d2.getTime();
        });
        return new BudgetsHandle(budgets, this.contractTypes);
    }
    getBudget(year, month) {
        const now = new Date(year, month);
        let capacity = (this.budgets || []).reduce((current, newDemand) => {
            const curentDemandTime = new Date(current?.year || 0, current?.month || 0).getTime();
            const newDemandTime = new Date(newDemand.year || 0, newDemand.month || 0).getTime();
            if (newDemandTime > now.getTime()) {
                return current;
            }
            else if (newDemandTime >= curentDemandTime) {
                return newDemand;
            }
            else {
                return current;
            }
        }, undefined);
        capacity = capacity || createEmptyBudget("");
        return new BudgetHandle_1.BudgetHandle(capacity, this.contractTypes);
    }
    getNewBudgetDate() {
        const now = new Date();
        return this.budgets.reduce((last, current) => {
            const currentDate = new Date(current?.year || 0, current?.month || 0);
            return last.getTime() > currentDate.getTime()
                ? last
                : new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
        }, new Date(now.getFullYear(), now.getMonth() + 1));
    }
    getContractHours(year, month) {
        return this.getBudget(year, month).getContractHours();
    }
    getPlannedHours(year, month) {
        return this.getBudget(year, month).getPlannedHours();
    }
}
exports.BudgetsHandle = BudgetsHandle;
//# sourceMappingURL=BudgetsHandle.js.map